import createRoutine from '@/utils/createRoutine'

export const notificationRoutine = createRoutine('notificationRoutine')

export const notificationGetters = {
  NOTIFICATION_CONFIG: 'NOTIFICATION_CONFIG'
}

export const NOTIFICATION_CLEANUP = 'NOTIFICATION_CLEANUP'
